/**
 * Si este negocio enseña el tráfico de prueba.
 *
 * En un DEMO el laboratorio ES el tráfico: arrancar apagado deja el tablero
 * vacío y parece roto. En un negocio real arranca apagado (FR-055).
 *
 * La elección se recuerda POR negocio. Apagarlo en Aurora no enciende Dental;
 * y un real no hereda el «on» de un demo.
 */
export function claveIncluirTests(accountId: string): string {
    return `agendify.incluirTests.${accountId}`
}

export function leerIncluirTests(accountId: string): boolean | null {
    try {
        const v = localStorage.getItem(claveIncluirTests(accountId))
        if (v === '1') return true
        if (v === '0') return false
    } catch {
        /* modo privado */
    }
    return null
}

export function escribirIncluirTests(accountId: string, v: boolean): void {
    try {
        localStorage.setItem(claveIncluirTests(accountId), v ? '1' : '0')
    } catch {
        /* modo privado */
    }
}

export function defectoIncluirTests(esDemo: boolean | undefined, guardada: boolean | null): boolean | null {
    if (esDemo === true) return true
    if (guardada !== null) return guardada
    if (esDemo === undefined) return null
    return false
}

/**
 * Qué laboratorio ve esta pantalla (spec 035).
 *
 * El admin decide (021). El cliente de un demo ve la demo; el de un real, no.
 * `null` = aún no se sabe si es demo: no se pide el resumen a ciegas.
 */
export function incluirTestsEnVista(
    esAdminUi: boolean,
    esDemo: boolean | undefined,
    preferencia: boolean,
): boolean | null {
    if (esDemo === undefined) return null
    // Demo: el canal ES el laboratorio (025 · FR-005). Un «off» guardado
    // deja el tablero vacío y parece que no hay conversaciones.
    if (esDemo) return true
    if (!esAdminUi) return false
    return preferencia
}

/** La portada admin no es un negocio: es otra clave. (spec 021) */
export const CLAVE_INCLUIR_TESTS_PORTADA = 'agendify.portada.incluirTests'

/** `0` apaga. Cualquier otra cosa —incluida no haber tocado nunca— enciende. */
export function interpretarIncluirTestsPortada(crudo: string | null): boolean {
    return crudo !== '0'
}

export function leerIncluirTestsPortada(): boolean {
    try {
        return interpretarIncluirTestsPortada(localStorage.getItem(CLAVE_INCLUIR_TESTS_PORTADA))
    } catch {
        return true
    }
}

export function escribirIncluirTestsPortada(v: boolean): void {
    try {
        localStorage.setItem(CLAVE_INCLUIR_TESTS_PORTADA, v ? '1' : '0')
    } catch {
        /* modo privado */
    }
}
